import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
  getPeriods (params) {
    return Api().get("/activity-company-periods/"+params);
  },
  updatePeriod (params) {
    return Api().put("/activity-company-periods",params);
  },
  addPeriod (params) {
    return Api().post("/activity-company-periods",params);
  },
  getPeriod (params) {
    return Api().get("/activity-company-periods/"+params);
  },
  deletePeriod (params) {
    return Api().delete("/activity-company-periods/"+params);
  },
  getPeriodsByCompany (params) {
    return Api().get("/activity-company-periods-by-company/"+params);
  },
  getReportExcel () {
    return Api().get("/activity-export-excel/");
  },
}



// WEBPACK FOOTER //
// ./src/services/ActivityCompanyPeriodService.js